# English language
app:
  title: "VINPROP - Real Estate"
  home_title: "Vietnam Real Estate for Sale | Investment Property | VINPROP"
  copyright: "© VINPROP 2024-2025"

common:
  view_all: "View all"
  send: "Send"
  cancel: "Cancel"
  ok: "OK"
  back: "Back"
  next: "Next"
  scroll_prev: "Previous"
  scroll_next: "Next items"
  loading: "Loading..."
  error: "Error"
  success: "Success"
  back_to_home: "Back to Home"
  select: "Select"
  selected: "Selected"
  error_with_message: "Error: {message}"
  menu: "Menu"
  close: "Close"
header:
  hero_text: "Up-to-date catalog of all new buildings in Vietnam"

menu:
  projects_buy: "Buy Real Estate"
  residential_complexes: "Residential Projects"
  gated_communities: "Gated Communities"
  holiday_homes: "Resort Property"
  commercial_real_estate: "Commercial Real Estate"
  services: "Services"
  handbook: "Real Estate Handbook"
  research_analytics: "Research and Analytics"
  news_blog: "News"
  agents: "For Agents"
  articles: "Articles"
  articles_sub:
    buy_real_estate_vietnam: "Buy Real Estate in Vietnam"
    analytics: "Market Analytics"
    investment: "Investment"
  callback: "Callback"
  view_all: "View all"

breadcrumbs:
  home: "Home"

search:
  project_type: "Project Type"
  location: "Location"
  bedroom: "Number of Bedrooms"
  min_price: "Minimum Price USD"
  max_price: "Maximum Price USD"
  search_button: "Search"
  price: "Price"
  reset: "Reset"
  room_single: "room"
  room_few: "rooms"
  room_many: "rooms"
  project_types:
    residential_complex: "Residential Project"
    gated_community: "Gated Community"
    villa: "Villa"
    holiday_homes: "Resort Property"
    commercial_real_estate: "Commercial Real Estate"
  rooms:
    one: "1 bedroom"
    many: "{count} bedrooms"
    more: "5+ bedrooms"
  from_price: "from {price}"
  to_price: "to {price}"

object_type:
  invalid: "Not specified"
  villa: "Villa"
  condotel: "Condotel"
  shophouse: "Shophouse"
  apartment: "Apartment"
  studio: "Studio"
  penthouse: "Penthouse"
  duplex: "Duplex"

amenities:
  invalid: "Not specified"
  bar: "Bar"
  restaurant: "Restaurant"
  spa: "Spa"
  yoga: "Yoga"
  convenience_store: "Convenience Store"
  shopping_mall: "Shopping Mall"
  school: "School"
  kindergarten: "Kindergarten"
  college: "College"
  swimming_pool: "Swimming Pool"
  kids_playground: "Kids Playground"
  gym: "Gym"
  community_room: "Community Room"
  jogging_path: "Jogging Path"
  bbq: "BBQ"
  green_area: "Green Area"
  tennis_court: "Tennis Court"
  kids_pool: "Kids Pool"
  parking: "Parking"
  cafe: "Cafe"

countries:
  af: "Afghanistan"
  al: "Albania"
  dz: "Algeria"
  ad: "Andorra"
  ao: "Angola"
  ag: "Antigua and Barbuda"
  ar: "Argentina"
  am: "Armenia"
  au: "Australia"
  at: "Austria"
  az: "Azerbaijan"
  bs: "Bahamas"
  bh: "Bahrain"
  bd: "Bangladesh"
  bb: "Barbados"
  by: "Belarus"
  be: "Belgium"
  bz: "Belize"
  bj: "Benin"
  bt: "Bhutan"
  bo: "Bolivia"
  ba: "Bosnia and Herzegovina"
  bw: "Botswana"
  br: "Brazil"
  bn: "Brunei"
  bg: "Bulgaria"
  bf: "Burkina Faso"
  bi: "Burundi"
  kh: "Cambodia"
  cm: "Cameroon"
  ca: "Canada"
  cv: "Cape Verde"
  cf: "Central African Republic"
  td: "Chad"
  cl: "Chile"
  cn: "China"
  co: "Colombia"
  km: "Comoros"
  cg: "Congo"
  cd: "DR Congo"
  cr: "Costa Rica"
  ci: "Ivory Coast"
  hr: "Croatia"
  cu: "Cuba"
  cy: "Cyprus"
  cz: "Czech Republic"
  dk: "Denmark"
  dj: "Djibouti"
  dm: "Dominica"
  do: "Dominican Republic"
  ec: "Ecuador"
  eg: "Egypt"
  sv: "El Salvador"
  gq: "Equatorial Guinea"
  er: "Eritrea"
  ee: "Estonia"
  sz: "Eswatini"
  et: "Ethiopia"
  fj: "Fiji"
  fi: "Finland"
  fr: "France"
  ga: "Gabon"
  gm: "Gambia"
  ge: "Georgia"
  de: "Germany"
  gh: "Ghana"
  gr: "Greece"
  gd: "Grenada"
  gt: "Guatemala"
  gn: "Guinea"
  gw: "Guinea-Bissau"
  gy: "Guyana"
  ht: "Haiti"
  hn: "Honduras"
  hk: "Hong Kong"
  hu: "Hungary"
  is: "Iceland"
  in: "India"
  id: "Indonesia"
  ir: "Iran"
  iq: "Iraq"
  ie: "Ireland"
  il: "Israel"
  it: "Italy"
  jm: "Jamaica"
  jp: "Japan"
  jo: "Jordan"
  kz: "Kazakhstan"
  ke: "Kenya"
  ki: "Kiribati"
  kp: "North Korea"
  kr: "South Korea"
  kw: "Kuwait"
  kg: "Kyrgyzstan"
  la: "Laos"
  lv: "Latvia"
  lb: "Lebanon"
  ls: "Lesotho"
  lr: "Liberia"
  ly: "Libya"
  li: "Liechtenstein"
  lt: "Lithuania"
  lu: "Luxembourg"
  mo: "Macau"
  mg: "Madagascar"
  mw: "Malawi"
  my: "Malaysia"
  mv: "Maldives"
  ml: "Mali"
  mt: "Malta"
  mh: "Marshall Islands"
  mr: "Mauritania"
  mu: "Mauritius"
  mx: "Mexico"
  fm: "Micronesia"
  md: "Moldova"
  mc: "Monaco"
  mn: "Mongolia"
  me: "Montenegro"
  ma: "Morocco"
  mz: "Mozambique"
  mm: "Myanmar"
  na: "Namibia"
  nr: "Nauru"
  np: "Nepal"
  nl: "Netherlands"
  nz: "New Zealand"
  ni: "Nicaragua"
  ne: "Niger"
  ng: "Nigeria"
  mk: "North Macedonia"
  no: "Norway"
  om: "Oman"
  pk: "Pakistan"
  pw: "Palau"
  ps: "Palestine"
  pa: "Panama"
  pg: "Papua New Guinea"
  py: "Paraguay"
  pe: "Peru"
  ph: "Philippines"
  pl: "Poland"
  pt: "Portugal"
  qa: "Qatar"
  ro: "Romania"
  ru: "Russia"
  rw: "Rwanda"
  kn: "Saint Kitts and Nevis"
  lc: "Saint Lucia"
  vc: "Saint Vincent and the Grenadines"
  ws: "Samoa"
  sm: "San Marino"
  st: "Sao Tome and Principe"
  sa: "Saudi Arabia"
  sn: "Senegal"
  rs: "Serbia"
  sc: "Seychelles"
  sl: "Sierra Leone"
  sg: "Singapore"
  sk: "Slovakia"
  si: "Slovenia"
  sb: "Solomon Islands"
  so: "Somalia"
  za: "South Africa"
  ss: "South Sudan"
  es: "Spain"
  lk: "Sri Lanka"
  sd: "Sudan"
  sr: "Suriname"
  se: "Sweden"
  ch: "Switzerland"
  sy: "Syria"
  tw: "Taiwan"
  tj: "Tajikistan"
  tz: "Tanzania"
  th: "Thailand"
  tl: "East Timor"
  tg: "Togo"
  to: "Tonga"
  tt: "Trinidad and Tobago"
  tn: "Tunisia"
  tr: "Turkey"
  tm: "Turkmenistan"
  tv: "Tuvalu"
  ug: "Uganda"
  ua: "Ukraine"
  ae: "UAE"
  gb: "United Kingdom"
  us: "United States"
  uy: "Uruguay"
  uz: "Uzbekistan"
  vu: "Vanuatu"
  va: "Vatican City"
  ve: "Venezuela"
  vn: "Vietnam"
  ye: "Yemen"
  zm: "Zambia"
  zw: "Zimbabwe"

featured_listings:
  title: "Featured Properties"
  urban_title: "Best urban real estate deals for {month} {year}"
  resort_title: "Best resort real estate deals for {month} {year}"
  empty: "No featured properties available"
  months:
    1: "January"
    2: "February"
    3: "March"
    4: "April"
    5: "May"
    6: "June"
    7: "July"
    8: "August"
    9: "September"
    10: "October"
    11: "November"
    12: "December"

guides:
  title: "Real Estate Handbook"
  coming_soon: "This guide is coming soon. Stay tuned for updates!"
  market_guide: "VN RE Market Guide"
  legal_guide: "Legal Guide"
  pm_guide: "Property Management Guide"
  buying_guide: "Buying Guide"

articles:
  all_title: "Articles"
  related_title: "Related articles"
  empty: "No articles"
  count: "{count} article | {count} articles"
  type:
    news: "News"
    services: "Services"
    handbook: "Handbook"
    research_analytics: "Market Analytics"
    buy_guide: "Buy Real Estate in Vietnam"
    investment: "Investment"
    default: "Article"
    all: "All Articles"
  filtered_by_tag: "Articles by tag"
  page: "Page"
  image_not_available: "Image not available"
  unknown_date: "Date unknown"
  not_found: "Article not found"
  go_back: "Back to articles"
  property_guide:
    title: "Property Management Guide in Vietnam"
    property_types: "Property Types"
    property_costs: "Property Costs"
    legal_aspects: "Legal Aspects"
    ownership_rules: "Ownership Rules"
    insurance_guidelines: "Insurance Guidelines"
    mortgages: "Mortgages in Vietnam"
    taxation_policies: "Taxation Policies"
  related_articles:
    title: "Related Articles"
    no_articles: "No related articles"
    error: "Error loading articles"
  slider:
    aria_label: "Featured properties"
    loading: "Loading featured properties"

form:
  title: "Fill out the form"
  subtitle: "Our specialists will contact you shortly"
  name: "Name"
  name_placeholder: "Enter your name"
  name_required: "Name is required"
  phone: "Phone"
  phone_placeholder: "+84 XXX XXX XXX"
  phone_required: "Phone is required"
  phone_invalid: "Invalid phone format"
  city_optional: "City (optional)"
  city_not_found: "Nothing found — leave the field empty"
  comment_optional: "Comment (optional)"
  city_interest: "City of interest (optional)"
  city_interest_placeholder: "Start typing a name"
  channel_legend: "How should we reach you?"
  channel_whatsapp: "WhatsApp"
  channel_telegram: "Telegram"
  channel_phone: "Call"
  contact_whatsapp: "Phone for WhatsApp"
  contact_phone: "Phone for a call"
  contact_telegram: "Telegram"
  telegram_placeholder: "{'@'}username or phone number"
  telegram_hint: "A username or a number — both work, we will figure it out"
  telegram_mode_nick: "Enter a username"
  telegram_mode_phone: "Enter a number"
  telegram_will_write: "We will message you on Telegram at {contact}"
  email: "Email"
  email_placeholder: "Enter your email"
  email_invalid: "Invalid email format"
  comment: "Comment"
  comment_placeholder: "Enter your comment"
  message: "Message"
  message_placeholder: "Tell us about your preferences..."
  submit: "Submit"
  submit_error: "Form submission error"
  success_title: "Thank you for your inquiry!"
  success_message: "We have received your request and will contact you shortly"
  submit_another: "Submit another request"
  privacy_note: "By clicking the button, you agree to the privacy policy and personal data processing"

sidebar_form:
  agent_name_placeholder: "Oleg Morozov"
  agent_role: "VINPROP Agent"
  headline: "We'll find 3 best options for your budget"
  description: "with profitability forecast and payback period"
  submit: "Get a personal selection"

validation:
  required_name: "Name is required"
  required_phone: "Phone is required"
  invalid_phone: "Please enter a valid phone number"
  required_email: "Email is required"
  invalid_email: "Please enter a valid email"
  invalid_telegram: "A username needs at least 4 characters — check it or enter a number"

error:
  network: "Network error: {message}"
  server: "Server error: {message}"
  form_submit: "Failed to submit the form. Please try again later."
  general: "An error occurred"

residential_complex:
  all_title: "Real Estate"
  reset_filters: "Reset filters"
  no_complexes: "No residential complexes"
  more_details: "More details"
  all_loaded: "All complexes loaded"

complex_card:
  price_from: "from {price}"
  price_on_request: "Price on request"
  details: "Details"
  handover_date_not_specified: "Handover date not specified"
  handover_completed: "Completed"
  handover_in_years: "Handover in {years} {label}"
  handover_in_months: "Handover in {months} {label}"
  handover_in_year: "Handover in {year}"
  handover_in_quarter: "Handover in Q{quarter} {year}"
  quarter_1: "1"
  quarter_2: "2"
  quarter_3: "3"
  quarter_4: "4"
  from: "from"
  to: "to"
  sqm: "m²"
  area: "Area"
  price_range: "Price range"
  request_contacts: "Request contacts"
  apartments_available: "{count} apartments available"
  sold_out: "SOLD OUT"
  studio: "Studio"
  delivery_in: "Delivery in"

complex_features:
  invalid: "Not specified"
  favorites: "Favorites"
  docs_checked: "Docs checked"
  video_available: "Video available"
  handovered: "Handovered"
  pink_book_available: "Pink book available"
  available_for_foreigners: "Available for foreigners"

filters:
  title: "Filters"
  project_rank: "Project Rank"
  amenities_title: "Amenities"
  features_title: "Features"
  rank:
    invalid: "Not specified"
    affordable: "Affordable"
    mid_end: "Mid-End"
    high_end: "High-End"
    luxury: "Luxury"

complex_details:
  characteristics:
    due_date: "Due date"
    class: "Complex class"
    altitude: "Altitude"
    room_type: "Room type"
    transport: "Transport accessibility"
    info_not_available: "Information not available"
  features:
    reputable_developer: "Reputable Developer"
    installment_plan: "Installment Plan"
    full_legal_ground: "Full Legal Ground"
    high_appreciation_potential: "High Appreciation Potential"
  class_type:
    high_end: "High End"
    mid_range: "Mid Range"
    economy: "Economy"
    luxury: "Luxury"
    invalid: "Not specified"
  room_type:
    apartment: "Apartment"
    penthouse: "Penthouse"
    duplex: "Duplex"
    studio: "Studio"
    invalid: "Not specified"
  developer_label: "Developer"
  handover_date_label: "Handover Date"
  project_class_label: "Project Class"
  complex_by_developer: "Residential complex by developer {name}"
  infrastructure: "Complex infrastructure"
  construction_progress: "Construction progress"
  construction_progress_description: "Photos from the construction site of the residential complex"
  construction_progress_date: "Photos as of {date}"
  amenity_categories:
    establishment: "Establishments"
    for_children: "For children"
    sport: "Sports"
    entertainment: "Entertainment"
    outdoor: "Outdoor"
    common_area: "Common Areas"
  amenities:
    bar: "Bar"
    restaurant: "Restaurant"
    spa: "Spa"
    yoga: "Yoga"
    convenience_store: "Convenience Store"
    shopping_mall: "Shopping Mall"
    school: "School"
    kindergarten: "Kindergarten"
    college: "College"
    swimming_pool: "Swimming Pool"
    kids_playground: "Kids Playground"
    gym: "Gym"
    community_room: "Community Room"
    jogging_path: "Jogging Path"
    bbq: "BBQ"
    green_area: "Green Area"
    tennis_court: "Tennis Court"
    kids_pool: "Kids Pool"
    parking: "Parking"
    cafe: "Cafe"
  documents:
    construction_permit: "Construction Permit"
    land_use_right_certificate: "Land Use Right Certificate"
    bank_letter_of_guarantee: "Bank Letter of Guarantee"
    sale_permit: "Sale Permit"
    sale_permit_for_foreigners: "Sale Permit for Foreigners"
  foreigners_heading: "Can a foreigner buy property in {name}?"
  foreigners_yes: "Yes, {name} is sold to foreign buyers."
  foreigners_permit: "The developer holds a permit to sell to foreigners — the document was verified by VINPROP lawyers."
  foreigners_pink_book: "The project issues the pink book, the Vietnamese certificate of ownership."
  foreigners_law: "Under Vietnamese law foreigners may own up to 30% of the apartments in one building; ownership is granted for 50 years and can be extended."
  master_plan: "Master plan"
  about_project: "About project"
  location: "Location"
  finishing_options: "Finishing options"
  finishing_options_from: "Finishing options from {name}"
  about_developer: "About developer"
  documents_checking: "Documents checking"
  other_complexes: "Other complexes by developer"
  open_map: "Open map"
  more_about_finishing: "More about finishing options"
  go_to_developer_page: "Go to developer page"
  finishing_description: "Various finishing options are available for apartments"
  finishing_note: "Images are for reference only and may differ from actual finishing"
  developer_contacts: "Developer contacts"
  image_not_available: "Image not available"
  plan_not_available: "Plan not available"
  get_consultation: "Get consultation"
  price_range: "{min} - {max}"
  offers_available: "{count} offers available"
  contact_us: "Contact us"
  contact_description: "Fill out the form below and we will contact you shortly"
  available_apartments_in: "Available apartments in {name}"
  apartments_available: "Available apartments"
  special_offers: "Special offers"
  check_price_availability: "Check current prices and availability with the manager"
  bedrooms_count: "{count} bedrooms"
  bedrooms: "{count} bedrooms"
  studio: "Studio"
  rooms_unspecified: "Number of rooms not specified"
  units_available: "{count} available"
  buy_now: "Buy now"
  more_detailed: "More detailed"
  images:
    PROPERTY_IMAGE_TYPE_LAYOUT: "Floor plan"
    PROPERTY_IMAGE_TYPE_FINISHING: "Finishing options"
  object_type: "Object type"
  available_units: "Available"
  valid_until: "Valid until"
  established: "Established"
  total_projects: "Total projects"
  completed_projects: "Completed projects"
  years_experience: "Years of experience"
  visit_website: "Visit website"
  contact_form_intro: "Interested in {name}? Leave a request and our manager will contact you"
  benefit_consultation: "Free specialist consultation"
  benefit_price: "Current prices and special offers"
  benefit_viewing: "Property viewing arrangement"
  benefit_documents: "Assistance with document verification"
  full_address: "Full address"
  district: "District"
  city: "City"
  loading_map: "Loading map..."
  map_error: "Map loading error"
  map_placeholder: "Location map"
  open_in_google_maps: "Open in Google Maps"
  nearby_places: "Nearby places"
  meters: "m"
  photo_date: "Photo on {date}"
  total_photos: "Total photos: {count}"
  last_update: "Last update: {date}"
  documents_verified: "Documents verified"
  documents_description: "All project documents have been legally verified by our specialists"
  document_verified: "Verified"
  document_pending: "Pending"
  documents_note: "Document information is updated regularly. Contact the manager for current data."
  other_complexes_by: "Other complexes by {name}"
  view_details: "View details"
  no_other_complexes: "No other complexes from this developer yet"
  starting_price: "Starting price"

footer:
  contacts: "Contacts:"
  company_section: "Company"
  legal_section: "Legal"
  about: "About Us"
  about_vinprop_title: "About VINPROP"
  about_snippet: "VINPROP is an international proptech company specializing in Vietnam's real estate market. We combine technological solutions, analytics, and consulting for foreign and local investors. We offer the purchase of apartments, villas, and commercial real estate in Ho Chi Minh City, Hanoi, Da Nang, and other cities in Vietnam."
  projects_section: "Projects / buy real estate"
  residential_complexes: "Residential Projects"
  gated_communities: "Gated communities"
  holiday_homes: "Resort property"
  commercial_real_estate: "Commercial real estate"
  services_section: "Services"
  advisory_services: "Advisory services"
  legal_consultation: "Legal consultation"
  property_management: "Property management"
  fit_out: "Fit-out"
  partners: "For partners"
  legal_disclaimer: "Legal Disclaimer"
  terms_of_use: "Terms of Use"
  careers: "Careers"
  privacy_policy: "Privacy Policy"
  cookie_policy: "Cookie Policy"
  handbook_section: "Real Estate Handbook"
  buying_guide: "Buying guide"
  legal_guide: "Legal guide"
  pm_guide: "PM guide"
  market_guide: "VN RE market guide"
  developer_profiles: "Developer's profiles"
  research_section: "Research and Analytics"
  news_blog: "News / blog"

time:
  year_single: "year"
  year_few: "years"
  year_many: "years"
  month_single: "month"
  month_few: "months"
  month_many: "months"

cookie_consent:
  title: "Cookie Usage"
  description: "We use cookies to improve your experience on our website, analyze traffic, and personalize content. You can customize your preferences or accept all cookies."
  customize: "Customize"
  accept_all: "Accept All"
  reject_all: "Necessary Only"
  save_preferences: "Save Preferences"
  necessary: "Necessary Cookies"
  necessary_desc: "These cookies provide basic website functionality and cannot be disabled."
  analytics: "Analytics Cookies"
  analytics_desc: "Help us understand how visitors interact with our website by collecting anonymous statistics."
  marketing: "Marketing Cookies"
  marketing_desc: "Used to display relevant advertising and track the effectiveness of advertising campaigns."
  preferences: "Personalization Cookies"
  preferences_desc: "Save your preferences (language, theme, etc.) to improve your user experience."
city_autocomplete:
  placeholder: "Start typing a city…"
  min_chars: "Enter at least 2 characters"
  loading: "Loading…"
  not_found: "Nothing found"
  load_error: "Failed to load suggestions"
  retry: "Retry"
  clear: "Clear"
  manual_entry: "Enter manually: “{query}”"
  manual_suffix: "(entered manually)"
  back_to_search: "Back to directory search"

# DEV-1722: страница застройщика /developers/{slug}
# DEV-1719: two city pages with different intents — listing and guide.
city:
  catalog_title: "Property in {city}"
  catalog_seo_title: "Property for Sale in {city} — New Developments | VINPROP"
  guide_title: "{city}: A Property Buyer's Guide"
  # DEV-1097: <title> вкладки. Не равен H1 — у SSR для него свой шаблон
  # (ssr/internal/domain/services/city_page.go, cityGuideFormats.Title),
  # и по одному URL заголовок обязан быть один. Правка seo_title города
  # из админки главнее шаблона — как и в SSR.
  guide_seo_title: "{city} City Guide — Districts, Prices, Buying Property | VINPROP"
  guide_link: "About {city} →"
  catalog_link: "All projects in the city →"
  guide_crumb: "City guide"
  projects_title: "Projects in {city}"
  catalog_link_count: "All {count} projects in the city →"

# DEV-1758: cities hub /locations. Wording matches the SSR hub
# (ssr/internal/domain/services/city_page.go): one address, one page.
locations_hub:
  title: "Cities of Vietnam"
  seo_title: "Cities of Vietnam — property buyer's guides | VINPROP"
  intro: "Cities of Vietnam with a VINPROP guide: districts, infrastructure, prices and the rules for foreign buyers. Each city comes with the projects on sale there."
  empty: "City guides are being prepared."
  all: "All cities"
  crumb: "Cities"
  projects_count: "{count} project | {count} projects"

# DEV-1762: developers hub /developers
developers_hub:
  title: "Vietnam property developers"
  intro: "Companies whose projects are on sale at VINPROP. Each has a profile and the full list of residential complexes with prices and handover dates."
  empty: "The developer directory is currently empty."
  all: "All developers"

developer:
  projects: "Projects by this developer"
  no_projects: "This developer has no projects on sale right now."
  not_found: "Developer not found"

# DEV-1808: home hero — the H1 lives here, not in the header
home:
  hero:
    eyebrow: "VINPROP · Vietnam real estate"
    subtitle: "Apartment complexes, villas and resort projects across Vietnam — current prices and support in your language"
    all_cities: "All cities"
  stats:
    projects: "project in the catalogue | projects in the catalogue"
    cities: "city | cities"
